<template>
  <v-container class="recursos-pagina">
    <v-btn text :to="{ name: 'city.list' }">Voltar às instituições</v-btn>
    <h1>{{ municipioId ? 'Recursos da instituição' : 'Recursos do Estado' }}</h1>
    <p v-if="nomeInstituicao">{{ nomeInstituicao }}</p>
    <v-progress-linear v-if="carregando" indeterminate />
    <v-alert v-if="erro" type="info" outlined>{{ erro }}</v-alert>
    <p v-if="estado && !etapaRecursal">Os recursos serão liberados após a divulgação do resultado, conforme a etapa e o prazo da instituição.</p>
    <recursos-ciclo v-if="estado && etapaRecursal" :uf="uf" :ano="2026" :estado="estado" :municipios="instituicoes" :bloqueado="carregando" @registrado="carregar" />
  </v-container>
</template>
<script>
import { seloFechamentoAPI } from '../API/SeloFechamentoAPI';
import { normalizarDados, mensagemErro } from '../utils';
import RecursosCiclo from './RecursosCiclo.vue';
import { atualUfDefinition } from '@/helpers/utils';
export default {
  name: 'SeloRecursosPagina', components: { RecursosCiclo }, props: { municipioId: [String, Number] },
  data() { return { carregando: false, estado: null, municipios: [], erro: '' }; },
  computed: {
    uf() { return String(atualUfDefinition.uf || this.$store.state.uf || '').toUpperCase(); },
    instituicoes() { return this.municipioId ? this.municipios.filter(m => m.municipioId === Number(this.municipioId)) : this.municipios; },
    nomeInstituicao() { return this.municipioId && this.instituicoes.length ? this.instituicoes[0].nome : ''; },
    etapaRecursal() { return this.estado && this.estado.etapa >= 5; },
  },
  mounted() { this.carregar(); },
  watch: { municipioId() { this.carregar(); } },
  methods: {
    async carregar() {
      this.carregando = true; this.erro = '';
      try { const [estado, municipios] = await Promise.all([seloFechamentoAPI.estado(this.uf,2026),seloFechamentoAPI.municipios(this.uf,2026)]); this.estado=normalizarDados(estado.data); this.municipios=normalizarDados(municipios.data); }
      catch(error) { this.estado=null; this.erro=mensagemErro(error); }
      finally { this.carregando=false; }
    },
  },
};
</script>
<style scoped>.recursos-pagina { max-width: 1200px; padding: 28px; }h1 { font-size: 26px; margin-bottom: 12px; }</style>
